import React from "react";

const AchatUserCell = ({ user, adherents }) => {
  return (
    <div className="whitespace-nowrap max-w-[260px]">
      <div className="font-medium">
        {user?.prenom} {user?.nom}
      </div>
      {adherents?.length ? (
        (() => {
          const labels = adherents.map((a) => `${a.prenom} ${a.nom}`);
          const head = labels.slice(0, 3).join(", ");
          const more = labels.length > 3 ? ` +${labels.length - 3}` : "";
          return (
            <div
              className="text-xs text-slate-500 dark:text-slate-400 truncate"
              title={labels.join(", ")}
            >
              {head}
              {more}
            </div>
          );
        })()
      ) : (
        <div className="text-xs text-slate-400">—</div>
      )}
    </div>
  );
};

export default AchatUserCell;
